import { render, staticRenderFns } from "./unqualifiedRegistrationTemplate.vue?vue&type=template&id=71e700fe&scoped=true"
import script from "./unqualifiedRegistrationTemplate.vue?vue&type=script&lang=js"
export * from "./unqualifiedRegistrationTemplate.vue?vue&type=script&lang=js"
import style0 from "./unqualifiedRegistrationTemplate.vue?vue&type=style&index=0&id=71e700fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e700fe",
  null
  
)

export default component.exports